import { Directive, inject, input, OnInit } from '@angular/core';
import { FormPickerComponent } from '@core/components';
import { combineLatest, filter, map, switchMap } from 'rxjs';
import { RequestsApiService } from '@core/services/request/requests-api.service';
import { InstallZone } from '@core/types/InstallZone';
import { toObservable } from '@angular/core/rxjs-interop';

@Directive({
  selector: 'x-form-picker[xAttachZones]',
  standalone: true,
})
export class AttachZonesDirective implements OnInit {
  private readonly requestAPIService = inject(RequestsApiService);
  private readonly component = inject(FormPickerComponent);
  readonly $ownerId = input.required<number>({
    alias: 'ownerId',
  });
  readonly $contractorId = input.required<number>({
    alias: 'contractorId',
  });
  readonly $contractorSubdivisionId = input.required<number>({
    alias: 'contractorSubdivisionId',
  });
  readonly ownerId$ = toObservable(this.$ownerId);
  readonly contractorId$ = toObservable(this.$contractorId);
  readonly contractorSubdivisionId$ = toObservable(
    this.$contractorSubdivisionId,
  );

  ngOnInit() {
    // combineLatest, а не zip: при смене только подразделения zip ждал новой пары
    // значений и список оставался от прежнего подразделения
    this.component.items$ = combineLatest([
      this.ownerId$,
      this.contractorId$,
      this.contractorSubdivisionId$,
    ]).pipe(
      filter(conditions => conditions.every(Boolean)),
      switchMap(([ownerId, contractorId, contractorSubdivisionId]) =>
        this.requestAPIService.getZonesForClientAndContractor$(
          ownerId,
          contractorId,
          contractorSubdivisionId,
        ),
      ),
      map(result =>
        result.sort((a: InstallZone, b: InstallZone) =>
          a.name.localeCompare(b.name),
        ),
      ),
    );
  }
}
